// extracted by mini-css-extract-plugin
export default {"wrapper":"Assets_wrapper__31M8w","cardWrapper":"Assets_cardWrapper__-fXsn"};